import React, { memo, useEffect, useRef } from "react";
import { DgaCard, DgaStatusTag, DgaIcon } from "platformscode-new-react";
import { useNavigate } from "react-router-dom";
import moment from "moment-hijri";
import Card from "./Card";
function EventCard({ data }) {
  const navigate = useNavigate();


  // ✅ Convert Hijri end date
  const parts = data.date?.split("إلى :");
  const endDateHijri = parts?.[1]?.trim();
  const endDateGregorian = endDateHijri
    ? moment(endDateHijri, "iYYYY-iMM-iDD").toDate()
    : new Date();
  const isExpired = endDateGregorian < new Date();


  return (
    <div >


      {/* <DgaCard
        style={{ display: "block", height: "100%", width: "100%" }}
        image={data.img}
        cardTitle={data.title}
        description={data.description}
        primaryActionLabel="قراء المزيد"
        showSecondaryAction={false}
        onPrimaryAction={() =>
          !isExpired && navigate(`/event-details?id=${data.id}`)
        }
        showFeaturedIcon={false}
        // disabled={isExpired}
        effect="stroke"
      >
        <h4 style={{ fontSize: "14px" }}>
          {data.date}{" "}
          {isExpired && (
            <span className="expired-text">
              <DgaStatusTag
                color="red"
                label="منتهي"
                size="md"
                status="subtle"
              />
            </span>
          )}
        </h4>
      </DgaCard> */}



      <Card
        style={{ display: "block", height: "100%", width: "100%" }}
        image={data.img}
        title={data.title}
        description={data.description}
        primaryActionLabel="قراء المزيد"
        showPrimaryAction
        disablePrimaryAction="true"
        showSecondaryAction={false}
        logoImage={false}
        onPrimaryAction={() =>
          !isExpired && navigate(`/event-details?id=${data.id}`)
        }
        // disabled={isExpired}
        effect="stroke"
      >

        <div className="flex flex-col gap-[16px]">


          <div className="flex justify-start gap-[8px]">

            <DgaIcon
              color="#000000"
              icon="calendar-04"
              size={16}
              type=""
              variant="stroke"
            />
            <time style={{ fontSize: "14px" }}>
              {data.date}{" "}
            </time>
          </div>
          {isExpired && (
            <div className="expired-text !p-0">
              <DgaStatusTag
                color="red"
                label="منتهي"
                size="md"
                status="subtle"
              />
            </div>

          )}
        </div>
      </Card>

    </div>
  );
}

export default memo(EventCard);
